export default __webpack_public_path__ + "img/component-btn-pink.d7124f46.png";